var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"acseries-and-footer"},[_c('acseries'),_c('scfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }